/**
 * The About tab's section headings — Awards, Meet the Team — in the
 * overview's own voice: the line "Who we are" is set in, rather than a
 * numbered accordion row.
 */
// Below md this is the About intro's type, which every head on the tab
// takes — Services, Locations we service, Awards — so the tab reads in one
// voice.
export const ABOUT_SECTION_HEADING_CLASS =
    'm-0 font-sans font-medium tracking-[-0.025em] text-black md:text-[3rem] md:leading-[1.05] max-md:text-[1.5rem] max-md:leading-[1.25] max-md:font-medium max-md:tracking-[-0.025em] max-md:text-[#323232]';

/** The section's box: the accordion's gutters and cap, with room above and below. */
export const ABOUT_SECTION_CLASS = 'bg-ground max-md:px-6 md:px-[3.125rem]';
export const ABOUT_SECTION_CAP_CLASS =
    'mx-auto w-full max-w-[113.75rem] max-md:pt-10 max-md:pb-1 md:pt-[5rem] md:pb-[5rem]';
